import React from 'react'

const Array = ({value}) => {
    return JSON.stringify(value)
}

export default Array